import React, {useEffect, useState} from "react";
import styled from "styled-components";
import MainVideo from "../components/atoms/MainVideo";
import VideoInfoBox from "../components/molecules/VideoInfoBox";
import BottomContents from "../components/molecules/BottomContents";
import Popup from "../components/templates/Popup";
import Cookies from "js-cookie";
import HomeContents from "../components/organisms/HomeContents";
import {device} from "../assets/styles/media";
import TabHomeContents from "../components/organisms/TabHomeContents";
import {useMediaQuery} from "react-responsive";
import request from "../config/Axios";

const Container = styled.div`
    width: 100%;
    height: 100%;
    //overflow-x: hidden;
`;

const PopContainer = styled.div`
    display: flex;
    max-width: 100%;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    position: fixed;
    justify-content: center;
    gap: ${(props)=>props.popCnt < 5 ? '30px' : '0'};
    padding-top: 80px;
    left: 0;
    z-index: 499;


    ${device.tablet} {
        max-width: 100vw;
        width: 100%;
        margin: 0 auto;
        display: block;
    }

`;
const VisualArea = styled.div`
    position: relative;
    max-height: calc(100vh - 20vh);
    padding-top: 80px;
    overflow: hidden;

    ${device.tablet} {
        padding-top: 5vw;
        height: auto;
        overflow: visible;
        margin-bottom: 100px;
    }

    ${device.mobile} {
        padding-top: 58px;
    }
`;

const Home = () => {
        const isTablet = useMediaQuery({maxWidth: 1023});
        const [popList, setPopList] = useState([]);
        const [popCnt, setPopCnt] = useState(0);
        const [dayOffData, setDayOffData] = useState({});
        const [closedPopups, setClosedPopups] = useState([]);

        const [subList, setSubList] = useState([]);
        const visiblePops = popList.filter(
            (pop) =>
                Cookies.get(`pop-${pop.idx}`) !== 'hidden' && !closedPopups.includes(pop.idx + "")
        );
        const contentsList = [
            {title: "알림", link: "/notice", subList : subList},
            {title: "관람",  link: "/map"},
            {title: "전시",  link: "/program/museum"},
            {title: "이벤트", link: "/program/special"},
        ];

        useEffect(() => {
            (async () => {
                try {
                    const popupResponse = await request.get(`popup`);
                    let data = popupResponse?.data?.data.length > 5 ? popupResponse?.data?.data.slice(0,5) : popupResponse?.data?.data;
                    setPopList(data);
                    setPopCnt(popupResponse?.data?.data?.length);
                } catch (err) {
                    console.error('api 호출 중 에러 발생:', err);
                }

                try {
                    const today = new Date();
                    const formatted = today.toISOString().split('T')[0];
                    const dayOffResponse = await request.get(`dayoff/${formatted}`);
                    setDayOffData(dayOffResponse?.data?.data);
                } catch (err) {
                    console.error('api 호출 중 에러 발생: ', err);
                }

                try {
                    const latestResponse = await request.get(`main/latest`);
                    setSubList(latestResponse?.data?.data);
                } catch (err) {
                    console.error('api 호출 중 에러 발생:', err);
                }
            })();
        }, []);

        return (
            <>
                <Container>
                    {/* popup*/}
                    {visiblePops.length > 0 &&  (
                        <PopContainer popCnt={popCnt}>
                            {visiblePops.map((pop) => (
                                <Popup key={pop.idx}
                                       pop={pop}
                                       setClosedPopups={setClosedPopups}
                                       popCnt={popCnt}
                                       setPopCnt={setPopCnt}
                                />
                            ))}
                        </PopContainer>
                    )}
                    {/*video 배너 부분*/}
                    <VisualArea>
                        <MainVideo/>
                        <VideoInfoBox dayOffData={dayOffData} />
                    </VisualArea>
                    {/*  알림, 공지, 전시, 이벤트 */}
                    {!isTablet ? <HomeContents list={contentsList}/>
                        : <TabHomeContents list={contentsList}/>
                    }

                    {/*    자연을 담은 강아지숲 이야기  */}
                    <BottomContents/>
                </Container>
            </>
        );
    }
;

export default Home;
